export const ULTRAVOX_SDK_VERSION = "0.5.0";
